export default "__VITE_ASSET__CdhG2i2$__"